// extracted by mini-css-extract-plugin
export default {"title":"delete_title__9JlDH","buttonPart":"delete_buttonPart__hJ-Cy","buttonCancel":"delete_buttonCancel__3nybm","buttonDelete":"delete_buttonDelete__J93JD"};